import { createSlice, type PayloadAction } from "@reduxjs/toolkit"

interface Tier1VerificationState {
  showFacialVerification: boolean | null
}

const initialState: Tier1VerificationState = {
  showFacialVerification: null,
}

const tier1VerificationSlice = createSlice({
  name: "tier1Verification",
  initialState,
  reducers: {
    setShowFacialVerification: (state, action: PayloadAction<boolean | null>) => {
      state.showFacialVerification = action.payload
    },
  },
})

export const { setShowFacialVerification } = tier1VerificationSlice.actions
export default tier1VerificationSlice.reducer
